import React from "react";
import {Container} from "../../ui";
import {ImgBillingTree, ImgPci} from "../bounce-ui";

export const PaymentsImages = () => (
  <Container fullWidth row sx={{justifyContent: "center", gap: "25px", padding: "10px"}}>
    <ImgBillingTree />
    <ImgPci />
  </Container>
);
